import cssUtil from 'gw-portals-util-js/CssUtil';
import styles from './wizard-single-error-hashed.scss';
import baseTemplate from 'text!./wizard-single-error.html';
import controller from './WizardSingleErrorCtrl';

const template = cssUtil.hashTemplate(baseTemplate, styles);

export default {
    bindings: {
        error: '<'
    },
    template,
    controller
};
